// DO NOT EDIT -- generated from fs/services/emissary/worker.proto

import { IntegrationContent } from './emissary.proto';
import * as protobuf from '../../../google/protobuf';

export namespace EmissaryWorker {

  export const ScheduleContentEndpoint = "/grpc/emissary.EmissaryWorker/ScheduleContent";
  /**
   * Schedules given content to be transformed and sent to the integration associated with the given
   * integration config id or with any integration config linked to the given source id.
   */
  export function ScheduleContent(sender: (req: ScheduleContentRequest, endpoint: string) => Promise<{}>, req: ScheduleContentRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, ScheduleContentEndpoint),
      endpoint: ScheduleContentEndpoint
    };
  }

  export const BatchScheduleContentEndpoint = "/grpc/emissary.EmissaryWorker/BatchScheduleContent";
  /** BatchScheduleContent is the batch version of ScheduleContent for the same org. */
  export function BatchScheduleContent(sender: (req: BatchScheduleContentRequest, endpoint: string) => Promise<{}>, req: BatchScheduleContentRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, BatchScheduleContentEndpoint),
      endpoint: BatchScheduleContentEndpoint
    };
  }
}

export interface ScheduleContentRequest {
  orgId: string;
  config?: ScheduleContentRequest.IntegrationConfig | null;
  configSource?: ScheduleContentRequest.IntegrationConfigsBySource | null;
  content: IntegrationContent | null;
  /** Optional, but highly encouraged to reduce the likelihood that we send the given content multiple times. */
  idempotenceKey: string;
}

export namespace ScheduleContentRequest {
  export interface IntegrationConfig {
    configId: string;
  }

  export interface IntegrationConfigsBySource {
    /** The origin given when creating the integration config. */
    origin: string;
    /** The source id given when creating the integration config. */
    sourceId: string;
  }

  export enum destination {
    config = 2,
    configSource = 3
  }

  export function destination_oneof(m: ScheduleContentRequest): { opt: destination.config, val: ScheduleContentRequest.IntegrationConfig } | { opt: destination.configSource, val: ScheduleContentRequest.IntegrationConfigsBySource } | null {
    if (m.config != null) { return { opt: destination.config, val: m.config } }
    if (m.configSource != null) { return { opt: destination.configSource, val: m.configSource } }
    return null;
  }
}

export interface BatchScheduleContentRequest {
  /** this org_id must match the org_id in the requests, i.e., the whole request must be for the same org. */
  orgId: string;
  requests: ScheduleContentRequest[];
  /** Used to measure processing latency. Do not set unless you intend to affect processing metrics. */
  processedAt: protobuf.timestamp | null;
}
